import { useTitle } from "@/Utilities/Hooks";
import HomeLayout from "@/Layouts/HomeLayout";
import "@/../css/slick.css";
import "@/../css/slick-theme.css";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import { LabeledInput, LabeledTextarea } from "@/Components/Form";
import { Button, FormError } from "@/Components";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Inertia } from "@inertiajs/inertia";

const OurRecommendation = ({}) => {
  useTitle("Our recommendation for your company");

  const answers = usePage().props.answers;
  const result = usePage().props.result;

  const services = [
    {
      id: 1,
      title: "GHG",
      description:
        "GHG Protocol (Greenhouse Gas Protocol) is recommended for companies that are significant emitters of greenhouse gases, or those required to report carbon footprints under regulatory or voluntary schemes. It is particularly relevant for companies with operations outside the EU/EEA, as they may face different environmental regulations.",
    },
    {
      id: 2,
      title: "CSRD",
      description:
        "CSRD (Corporate Sustainability Reporting Directive) is mandatory for large companies and public-interest entities operating within the EU that meet specific legal size and activity criteria. This framework, including the ESRS, is essential for those part of a group with several companies, enabling comprehensive sustainability reporting across the group.",
    },
    {
      id: 3,
      title: "LCA & EPD",
      description:
        "LCA & EPD (Life Cycle Assessment, Environmental Product Declarations) is recommended for manufacturers of products interested in communicating the environmental impact of their products over their entire life cycle. This framework is suitable for companies seeking to enhance transparency and support eco-friendly product claims, especially useful if listed on the stock exchange where sustainability reporting can influence investor relations.",
    },
    {
      id: 4,
      title: "Double Materiality Analysis According to CSRD",
      description:
        "The EU's Corporate Sustainability Reporting Directive (CSRD) requires double materiality in reporting, covering: 1) Financial Materiality, impact of sustainability issues on financial performance. And 2) Environmental and Social Materiality, impact of company activities on the environment and society. CSRD mandates transparent reporting on both to provide a full view of sustainability performance, enhancing accountability and promoting sustainable practices.",
    },
    // {
    //   id: 5,
    //   title: "To be implemented",
    //   description: "This is not yet available",
    // },
  ];

  console.log(result);

  const recommendedServices = services.filter((s) => result.includes(s.id));

  return (
    <>
      <ul className="my-6 flex w-full max-w-[1182px] gap-2 self-center text-gray-inactive max-xl:px-4 max-sm:my-4">
        <li>
          <InertiaLink
            href={route("home")}
            className="underline hover:no-underline"
          >
            Home
          </InertiaLink>
        </li>
        <span>/</span>
        <li>Our recommendation</li>
      </ul>
      <section className="w-full max-w-[1182px] self-center bg-white p-10 max-md:px-4 lg:-mt-20 lg:p-16">
        <div className="mx-auto flex max-w-[820px] flex-col gap-10">
          <h1 className="text-6xl leading-[70px] max-md:text-4xl max-md:leading-10 max-sm:text-3xl">
            Our recommendation
          </h1>

          <div className="flex flex-col gap-4 border border-dashed border-gray-darker p-4 lg:p-8">
            <p className="text-gray-inactive">As you are</p>
            <h2 className="text-balance font-rozhaone text-3xl leading-9 text-black max-sm:text-2xl max-sm:leading-7">
              {`A ${answers.manufacturer_or_service_provider === "Services" ? "service provider" : "manufacturer"} with ${answers.employees_count} employees and a net turnover of ${answers.net_turnover}`}
            </h2>

            <div className="flex flex-wrap border-b border-gray pb-4 max-md:flex-col max-md:gap-4">
              <div className="basis-1/2-gap-4">
                <p className="text-gray-inactive">Industry</p>
                {answers?.industries?.map((industry, i) => (
                  <Tag key={i}>{industry}</Tag>
                ))}
              </div>
              <div className="basis-1/2-gap-4">
                <p className="text-gray-inactive">Clients</p>
                {answers?.customers?.map((customer, i) => (
                  <Tag key={i}>{customer}</Tag>
                ))}
              </div>
            </div>

            <ul className="ml-6 list-disc">
              {answers.operations_outside_eu_eea === "Yes" && (
                <li>Operates outside EU/EEA</li>
              )}
              {answers.part_of_group === "Yes" && (
                <li>Part of a group of companies</li>
              )}
              {answers.listed_on_stock_exchange === "Yes" && (
                <li>Listed on the stock exchange</li>
              )}
              {answers.owns_real_estate === "Yes" && <li>Owns real estate</li>}
            </ul>
          </div>
          <h3 className="text-md font-bold">
            Based on your answers, we recommend the following reporting methods
            or standards
          </h3>

          {recommendedServices.map((service, index) => (
            <FeatureItem key={index} {...service} />
          ))}
        </div>
      </section>

      <ContactSection />
    </>
  );
};

OurRecommendation.layout = (page) => <HomeLayout>{page}</HomeLayout>;

export default OurRecommendation;

function FeatureItem({ title, description }) {
  return (
    <div className="flex items-start gap-4">
      <img
        src="/images/home/check.svg"
        alt=""
        role="presentation"
        className="w-[35px] shrink-0 max-md:hidden"
      />
      <div className="border-b border-dashed border-gray-darker pb-4">
        <h2 className="mb-2 font-rozhaone text-3xl leading-9">
          <img
            src="/images/home/check.svg"
            alt=""
            role="presentation"
            className="mr-2 hidden w-[35px] shrink-0 max-md:inline-block"
          />
          {title}
        </h2>
        <p className="text-md leading-7 max-sm:text-base">{description}</p>
      </div>
    </div>
  );
}

function Tag({ children }) {
  return (
    <span className="mr-2 mt-2 inline-block bg-yellow px-3 py-2 text-md max-sm:text-base">
      {children}
    </span>
  );
}

const ContactSection = () => {
  const errors = usePage().props.errors;
  const result = usePage().props.result;

  const [data, setData] = useState({});
  const [isLocked, setIsLocked] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLocked(true);

    const urlParams = new URLSearchParams(window.location.search);

    const paramsObject = {};

    for (const [key, value] of urlParams.entries()) {
      const cleanKey = key.endsWith("[]") ? key.slice(0, -2) : key;

      if (cleanKey in paramsObject) {
        Array.isArray(paramsObject[cleanKey])
          ? paramsObject[cleanKey].push(value)
          : (paramsObject[cleanKey] = [paramsObject[cleanKey], value]);
      } else {
        paramsObject[cleanKey] = key.endsWith("[]") ? [value] : value;
      }
    }

    const payload = {
      ...data,
      answers: paramsObject,
      result: result,
    };

    const id = toast.loading("Please wait...");

    Inertia.post(route("recommendation.result.contact"), payload, {
      preserveScroll: true,
      onSuccess: () => {
        toast.update(id, {
          render:
            "Thank you for contacting us! We will get in touch with you soon",
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          closeButton: true,
        });
        setData({});
      },
      onError: () => {
        toast.update(id, {
          render: "Something went wrong. Please try again later",
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
        });
      },
      onFinish: () => {
        setIsLocked(false);
      },
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className="relative">
      <img
        loading="lazy"
        src="/images/decorative-polygon-yellow.svg"
        alt=""
        role="presentation"
        className="absolute bottom-0 left-0 top-0 max-w-full"
      />
      <form
        className="relative z-10 mx-auto flex w-full max-w-[584px] flex-col gap-4 max-md:mt-10 max-md:px-4"
        onSubmit={handleSubmit}
      >
        <div className="flex gap-8 max-md:flex-col max-md:items-center">
          <img
            src="/images/georg.png"
            alt="Headshot of Georg Eriksson, CEO of Gidås"
            className="h-[100px] w-[100px] shrink-0 rounded-full"
          />
          <div>
            <h2 className="mb-2 font-rozhaone text-3xl leading-9">
              Let's get started!
            </h2>
            <p className="text-md">
              Submit your results and you will be contacted by a specialist to
              discuss your next step
            </p>
          </div>
        </div>

        <LabeledInput
          title="Name*"
          name="name"
          placeholder="Enter your name"
          required
          autoComplete="name"
          value={data?.name || ""}
          onChange={onChange}
          error={errors?.name}
        />
        <LabeledInput
          title="Company*"
          name="company"
          placeholder="Enter your company's name"
          required
          autoComplete="organization"
          value={data?.company || ""}
          onChange={onChange}
          error={errors?.company}
        />
        <LabeledInput
          title="Email*"
          name="email"
          placeholder="Enter your email address"
          type="email"
          required
          autoComplete="email"
          value={data?.email || ""}
          onChange={onChange}
          error={errors?.email}
        />
        <LabeledTextarea
          title="Other information that might be good for us to know"
          name="other"
          value={data?.other || ""}
          onChange={onChange}
          error={errors?.other}
        />

        <div>
          <input
            type="checkbox"
            id="terms"
            name="terms"
            className="mr-2"
            required
            checked={data?.terms || false}
            onChange={(e) =>
              setData((prev) => ({ ...prev, terms: e.target.checked }))
            }
          />
          <label htmlFor="terms">
            I have read and understood the&nbsp;
            <a
              target="_blank"
              className="underline hover:no-underline"
              href="https://www.dille.se/integritet/"
            >
              privacy policy
            </a>
            *
          </label>
          {errors?.term && <FormError error={errors.terms} />}
        </div>

        <Button disabled={isLocked} className="mt-4">
          Submit your result
        </Button>
      </form>
    </section>
  );
};
